import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { Colors } from '../constants'
import { useSettings } from '../providers'

export function DeadlinesDisplay() {
  const { settings } = useSettings()
  const [now, setNow] = useState(new Date().getTime())

  let intervalId: ReturnType<typeof setTimeout>
  useEffect(() => {
    intervalId = setInterval(updateDeadlines, 1000)
    return () => clearInterval(intervalId)
  }, [])

  function updateDeadlines() {
    setNow(new Date().getTime())
  }

  const submitDeadlineDisplay = new Date(now + settings.submitDeadline * 1000).toLocaleString()
  const executionDeadlineDisplay = new Date(now + settings.executionDeadline * 1000).toLocaleString()

  return (
    <Deadline>
      Your order will revert unless it is mined before <strong>{submitDeadlineDisplay}</strong> and executed before{' '}
      <strong>{executionDeadlineDisplay}</strong>.
    </Deadline>
  )
}

const Deadline = styled.p`
  font-size: 10px;
  color: ${Colors.DarkerGray};
`
